import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const schoolsApi = {
  createAdmin: (data) => api.post('/schools/admin', data).then(unwrap),
  getById: (id) => api.get(`/schools/${id}`).then(unwrap),
  updateTheme: (id, data) => api.put(`/schools/${id}/theme`, data).then(unwrap),
  uploadLogo: (id, formData) =>
    api.put(`/schools/${id}/logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(unwrap),
  updateFeatures: (id, data) => api.put(`/schools/${id}/features`, data).then(unwrap),
  updateAdmissionFormat: (id, data) => api.put(`/schools/${id}/admission-format`, data).then(unwrap),
  previewAdmissionFormat: (id, params) =>
    api.get(`/schools/${id}/admission-format/preview`, { params }).then(unwrap),
  updateRazorpay: (id, data) => api.put(`/schools/${id}/razorpay`, data).then(unwrap),
  getLanding: (id) => api.get(`/schools/${id}/landing`).then(unwrap),
  updateLanding: (id, data) => api.put(`/schools/${id}/landing`, data).then(unwrap),
}

export const settingsApi = {
  changePassword: (data) => api.put('/auth/change-password', data).then(unwrap),
  getSchool: (schoolId) => api.get(`/schools/${schoolId}`).then(unwrap),
  updateSchool: (schoolId, data) => api.put(`/schools/${schoolId}`, data).then(unwrap),
  updateFeatures: (schoolId, data) => api.put(`/schools/${schoolId}/features`, data).then(unwrap),
}
